import { ConnectionState } from "ng-connection-service";
import { SelectItem } from "primeng/api";

export class DataElement implements SelectItem {
  id: any;
  text: string;
  selected?: boolean;
  icon: string;
  altFilter: string;

  constructor(id: string = undefined, text: string = undefined) {
    this.id = id ? id.toString() : id;
    this.text = text;
  }

  get label(): string {
    return this.text;
  }

  get value() {
    return this;
  }
}

export class PaginationParams {
  rangeTo?: number;
  rangeFrom?: number;
  searchId?: number;
  numberOfRows?: number;
}
export class PaginationModel {
  filters?: any[];
  first?: number;
  globalFilter?: any;
  rows?: number;
  sortField?: string;
  sortOrder?: number;
}

export class FileUpload {
  file?: File;
  fileType?: string;
  fileUuid?: string;
  subFolder?: string;
  base64?: string | ArrayBuffer;
}

export class Doctor extends DataElement {
  clinicList?: string[] = [];

  constructor(id: string = undefined, text: string = undefined) {
    super(id, text);
  }
}

export class PresignedUrlResult {
  uploadUrl: string;
  destFileUrl: string;
  s3Key: string;
}

export class ProcessRunStatusResult {
  status: ProcessRunStatusEnum;
  errorCode: string;
  errorMsg: string;
  outFileUrl: string;
}

export class ServerError {
  errorCode?: string;
  message?: string;
  serviceName?: string;
  url?: string;
  req?: string;
  rep?: string;
  userId?: string;
  networkError?: boolean = false;
  isServerError?: boolean = true;
}

export class ServiceCallInfo {
  serviceName?: string;
  url?: string;
  req?: string;
  algServicesSw?: boolean;
  alertWhenOffline: boolean = true;
  online?: boolean = true;
  // false for a background call whose caller ignores a failure: no error dialog
  alertOnError: boolean = true;

  constructor(
    serviceName: string,
    url: string,
    req: string,
    algServicesSw: boolean = false
  ) {
    this.serviceName = serviceName;
    this.url = url;
    this.req = req;
    this.algServicesSw = algServicesSw;
  }
}

/* == ENUMS == */

export class ProcessRunStatusEnum {
  public static PENDING: string = "PENDING";
  public static RUNNING: string = "RUNNING";
  public static FINISHED: string = "DONE";
  public static FAILED: string = "ERROR";
}
